module.exports = __webpack_public_path__ + "static/media/logo-login.2435bdcd.png";